import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
declare let gtag: Function;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

//https://dottedsquirrel.com/everything-else/add-google-analytics-angular/

export class AppComponent implements OnInit  {
  title = 'app';

  RemoveSpace$ = false;

  onActivate(event) {
    
    if (!location.hash) {
      window.scroll(0, 0);
    }
  }

  constructor(private route: ActivatedRoute, private router: Router) {
  
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-E0HNTC29JS',
          {
            'page_path': event.urlAfterRedirects
          }
        );
      }
    });
  }

  ngOnInit() {

    this.route.queryParams.subscribe((params) => {
      const hideNav = params['hidenav'];
      this.RemoveSpace$ = (hideNav === 'true');
    });
  }

  getHeaderClass() {
    this.route.queryParams.subscribe((params) => {
      const hideNav = params['hidenav'];
      if (hideNav === 'true') {
        return "pt-0";
      }
      else
        return "pt-6";
    });
  }
}
